import { Grid } from '@mui/material'
import { PATH_PGSSE } from 'home/constants/RouteConstants'
import PgsseAction from 'pgsse/action/PgsseAction'
import { getUdiSectorName } from 'pgsse/util/PgsseUtil'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import i18n from 'simple-react-i18n'
import useTitle from 'utils/customHook/useTitle'
import DiagnosisCard from './DiagnosisCard'
import useActions from 'utils/customHook/useActions'
import ToastrAction from 'toastr/actions/ToastrAction'

const PgsseDangerDiagnosisApp = () => {
    const dispatch = useDispatch()

    const { idDiagnostic } = useParams()

    const {
        distributionUnits,
        sectors,
        diagnostic: propsDiagnostic,
    } = useSelector(store => ({
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        sectors: store.SectorReducer.sectors,
        diagnostic: store.PgsseReducer.diagnostic,
    }), shallowEqual)

    const [diagnostic, setDiagnostic] = useState(propsDiagnostic)

    useEffect(() => {
        dispatch(PgsseAction.fetchDiagnostic(idDiagnostic))
    }, [])

    useEffect(() => {
        setDiagnostic(propsDiagnostic)
    }, [propsDiagnostic])

    useTitle(() => {
        const udi = distributionUnits.find(du => du.id === diagnostic.idUdi)
        const sector = sectors.find(s => s.id === diagnostic.idSector)
        return [{
            title: i18n.pgsse,
            href: PATH_PGSSE,
        }, {
            title: i18n.phase2,
            href: `${PATH_PGSSE}/phase2`,
        }, {
            title: getUdiSectorName(udi, sector),
            href: `${PATH_PGSSE}/phase2/${diagnostic.idDiag}`,
        }, {
            title: i18n.diagnostic,
            href: `${PATH_PGSSE}/phase2/diagnosis/${diagnostic.idDiag}`,
        }]
    }, [diagnostic])

    useActions(() => ({
        exportList: [{
            onClick: () => dispatch(ToastrAction.info(i18n.inDeveloppmentFunctionnality)),
            label: i18n.excel,
        }],
    }), [diagnostic, idDiagnostic])

    return (
        <Grid container spacing={1} sx={{ padding: '1rem' }} size={12}>
            <DiagnosisCard/>
        </Grid>
    )
}

export default PgsseDangerDiagnosisApp
